<!--
  @Description 历史问题汇总
  @Date 2023-02-06
  @Author liufu
-->
<template>
  <div class="container">
    <homeHeader ref="HomeHeader" :isShowProjectSelect="true" @changeSelect="changeSelect" key="summary"></homeHeader>

    <div class="main">
      <!-- 表格 -->
      <div class="card">
        <!-- 按钮组 -->
        <div class="toolbar-dv">
          <toolBarBtn
            @changeSearchFormShow="changeSearchFormShow"
            :parentData="this"
            ref="toolBarBtn"
            :moreButtonList="moreButtonList"
            :buttonVisible="buttonVisible"
          ></toolBarBtn>
        </div>

        <!-- 查找面板 -->
        <div class="search-dv" v-if="searchFormVisible">
          <SearchForm ref="SearchForm"></SearchForm>
        </div>

        <!-- 表格 -->
        <div class="table-dv">
          <vxe-grid
            ref="xTable"
            resizable
            :data="tableData"
            size="mini"
            :mouse-config="{ area: true }"
            highlight-hover-row
            highlight-current-row
            :height="tableHeight"
            :columns="gridColumns"
            :cell-style="tableCellStyle"
            @cell-dblclick="handleDbClick"
            :row-config="{ height: 60 }"
            :showOverflow="true"
            :tooltip-config="{
              showAll: true,
              theme: 'dark'
            }"
            :keyboard-config="{
              isArrow: true,
              isEnter: true,
              isTab: true,
              isClip: true,
              enterToTab: true,
              isEdit: true
            }"
            @menu-click="contextMenuClickEvent"
            :menu-config="{ body: { options: bodyMenus }, visibleMethod }"
            @cell-menu="cellContextMenuEvent"
            :scroll-y="{
              mode: 'wheel'
            }"
            :seq-config="{
              startIndex: (tablePage.currentPage - 1) * tablePage.pageSize
            }"
            :pager-config="tablePage"
            @page-change="handlePageChange"
            :clip-config="{
              copyMethod: copyMethod
            }"
            show-footer
            :footer-method="footerMethod"
          >
          </vxe-grid>
        </div>
      </div>
    </div>

    <!-- 员工档案 -->
    <EmployeeSelect
      ref="EmployeeSelect"
      :isMultiple="false"
      :sqlTitle="personSqlTitle"
      @sureBackPerson="sureBackPerson"
      :isRequired="true"
    />

    <!-- 附件 -->
    <AttachmentDrawer
      ref="AttachmentDrawer"
      :attachmentDisplay.sync="attachmentDisplay"
      :parentObj="this"
      :edit="true"
      :keyValue="curSelectID"
    ></AttachmentDrawer>

    <!-- 设计变更 -->
    <SetDesignHistoryModel ref="SetDesignHistoryModel" />

    <!-- 设计变更历史抽屉 -->
    <QuestionUpdateHistory ref="QuestionUpdateHistory" />

    <!-- 说明编辑 -->
    <InstructionEdit ref="InstructionEdit" :id="curSelectID" :parentObj="this"></InstructionEdit>
  </div>
</template>

<script>
// 设计变更内容
import SetDesignHistoryModel from './YKCaseDesign/setDesignHistoryModel'
import QuestionUpdateHistory from './YKCaseDesign/QuestionUpdateHistory'
import InstructionEdit from './instructionEdit.vue'

export default {
  components: {
    InstructionEdit,
    SetDesignHistoryModel,
    QuestionUpdateHistory
  },
  data() {
    return {
      // 分页设置
      tablePage: {
        total: 0,
        currentPage: 1,
        // 默认每页条数
        pageSize: 200,
        align: 'right',
        // 每页条数
        pageSizes: [50, 100, 200, 500, 1000, 50000],
        layouts: ['Sizes', 'PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'FullJump', 'Total'],
        perfect: true
      },
      tableData: [],
      searchFormVisible: false,
      // 列
      gridColumns: [],
      // 正常状态下，需要加上表格距离card上下的margin
      topBottomMargin: 20,
      // 按钮组扩展按钮 { icon: xxx, name: xxx, event: xxx, visible: xxx }
      moreButtonList: [],
      // 是否显示附件弹窗
      attachmentDisplay: false,
      // 当前选中行的ID
      curSelectID: -1,
      // 当前选中行的ID列表
      curSelectAttchmentIDList: [],
      // 当前选中列名（用于判断要打开哪种类型的选择框，以及给哪一列赋值）
      curSelectCol: '',
      // 人员选择框过滤条件，格式如 'post:前端研发'
      personSqlTitle: '',
      // 是否全量查询问题 [全量 | 过滤本人]（用于缓存当前处于何种过滤状态，在操作结束后应按原先的过滤状态进行显示）
      isSearchAll: true,
      // 页面是否被锁定(除超级权限外，其他均不可操作)
      isLock: false,
      // 产品类型下拉框值
      optionsValue: '',
      // 批量输入框的类型 [文档编号 | 模块 | 页面]
      inputType: '',
      Authority: this.AuthorityFilter(this.$route.path),
      // 特殊权限
      specialAuthority: {},
      // 拉选区域
      areas: [],
      // 下拉框绑定值
      combobox: {
        // 产品类型选择框（铁塔、电杆等）
        ProductionType: []
      },
      // 右键菜单
      bodyMenus: [
        [
          {
            code: 'selectCheckbox',
            name: '选中'
          },
          {
            code: 'isPriority',
            name: '是'
          },
          {
            code: 'isPriority',
            name: '否'
          },
          {
            code: 'leaderViews',
            name: '新增领导意见'
          },
          {
            code: 'caseStatus',
            name: '不处理',
            // 后缀图标
            // suffixIcon: 'el-icon-s-tools'
            prefixIcon: 'el-icon-circle-close'
          },
          {
            code: 'caseStatus',
            name: '恢复处理',
            // 前缀图标
            prefixIcon: 'el-icon-refresh-right'
          },
          {
            code: 'sign',
            name: '签名'
          },
          {
            code: 'unSign',
            name: '撤销签名'
          },
          {
            code: 'comment',
            name: '新增说明'
          },
          {
            code: 'type',
            name: '完善'
          },
          {
            code: 'type',
            name: '新增'
          },
          {
            code: 'type',
            name: '错误'
          },
          {
            code: 'type',
            name: '性能'
          },
          {
            code: 'workTime',
            name: '互评工作量'
          },
          {
            code: 'daySelect',
            name: '选择天数'
          },
          {
            code: 'docNumber',
            name: '修改文档编号'
          },
          {
            code: 'vuePath',
            name: '修改页面名称'
          },
          {
            code: 'groupName',
            name: '修改模块'
          },
          {
            code: 'setDesign',
            name: '新增设计变更'
          },
          {
            code: 'searchDesign',
            name: '查看历史变更记录'
          }
        ],
        [
          {
            code: 'caseStatusSet',
            name: '解决中'
          },
          {
            code: 'caseStatusSet',
            name: '技术测试通过'
          },
          {
            code: 'caseStatusSet',
            name: '业务测试通过'
          },
          {
            code: 'caseStatusSet',
            name: '已解决'
          },
          {
            code: 'caseStatusSet',
            name: '超期未解决'
          },
          {
            code: 'caseStatusSet',
            name: '超期已解决'
          }
        ]
      ],
      buttonVisible: {
        add: false, // 新增按钮是否显示
        update: false, // 编辑按钮是否显示
        delete: false, // 删除按钮是否显示
        save: true, // 保存按钮是否显示
        lock: true, // 锁定按钮是否显示
        unlock: true, // 解锁按钮是否显示
        sort: true, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      },
      // 人员岗位类型常量（用于签名、修改解决人等，与后端预设值保持一致）
      PERSONTYPE: {
        frontEngineer: '前端研发',
        backEngineer: '后端研发',
        techTester: '技术测试',
        businessTester: '业务测试',
        createtor: '提出人',
        research: '调研人',
        // 用于互评工作量，前后端需颠倒
        frontWorkTime: '后端评价人',
        backWorkTime: '前端评价人',
        // 用于改评价人，无需颠倒
        frontAssessor: '前端评价人',
        backAssessor: '后端评价人',
        techTestDay: '技术测试',
        businessTestDay: '业务测试',
        confirmDay: '提出人'
      },
      // 用于人员选择框过滤用的字典
      perSqlTitleMap: {
        createtor: '项目经理',
        research: '',
        frontEngineer: '前端研发',
        backEngineer: '后端研发',
        techTester: '技术测试',
        businessTester: '业务测试',
        // 前端和后端评价人，对应前端和后端研发人员
        frontAssessor: '前端研发',
        backAssessor: '后端研发'
      },
      // 单元格背景颜色字典
      cellBgColorMap: {
        yellow: '#FBFE56',
        orange: '#FFC000',
        purple: '#B791C6',
        red: '#FF8B8B',
        green: '#61BFAD',
        pink: '#F1C3B8'
      },
      // 单元格字体颜色（根据背景颜色匹配，key为背景颜色，value为文本颜色）
      cellTextColorMap: {
        yellow: '#101010',
        orange: '#101010',
        purple: '#000000',
        red: '#F9F8E6',
        green: '#FFFFFF',
        pink: '#101010'
      }
    }
  },
  created() {
    if (this.$store?.state?.systemSetting && this.$store?.state?.systemSetting.defaultSearch === 'my') {
      this.isSearchAll = false
    }
    this.InitColumns()
    this.getSpecial()
    this.bindCombobox()
  },
  async activated() {
    // 获取当前是否被锁定
    await this.getIsLock()
    // 注意！要先执行完 getIsLocak 才能根据锁定状态来初始化工具栏的锁定/解锁按钮
    this.initButton()
  },
  methods: {
    // 复制内容方法
    copyMethod({ row, column, cellValue }) {
      switch (column.property) {
        case 'designHistory':
        case 'comment':
          return this.formatContentWrap(row, column, 'left', true, true)
        default:
          return cellValue
      }
    },
    // 查看设计变更
    async openDesignHistoryWindow(body) {
      const { data: res } = await this.$http.post('/Common/YKCaseDesign/history', body)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      // --------------判断是否为单行--------------
      let hasLeft = false
      let hasRight = false
      // 默认单行
      let dataIsSingleCol = true
      for (let item of res.data) {
        if (['后端', '数据库'].includes(item.type)) {
          hasRight = true
        } else {
          hasLeft = true
        }
        // 如果都有数据的话就为多行
        if (hasLeft && hasRight) {
          dataIsSingleCol = false
          break
        }
      }
      this.$refs.QuestionUpdateHistory.dataIsSingleCol = dataIsSingleCol
      // -----------------------------------------

      this.$refs.QuestionUpdateHistory.questionHistoryList = res.data
      this.$refs.QuestionUpdateHistory.showDrawer = true
    },
    // 设置本行设计变更
    setRowDesign(row) {
      this.$refs.SetDesignHistoryModel.row = row
      this.$refs.SetDesignHistoryModel.isShow = true
    },
    // 设置列
    InitColumns() {
      // width
      // 35: 两个字两行
      // 50: 两个字
      // 55: 四个字两行
      // 65: 三个字
      // 75: 四个字
      this.gridColumns = [
        { type: 'seq', width: 60, fixed: 'left' },
        // {
        //   fixed: 'left',
        //   type: 'checkbox',
        //   width: '50px'
        // },
        {
          title: '是否已下发',
          fixed: 'left',
          field: 'isIssued',
          width: '60px',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        // 问题编号宽度55可以容纳四位数序号，如：T1657
        {
          title: '问题编号',
          width: 55,
          field: 'num',
          filters: [{ data: { val1: '', val2: '' } }],
          filterRender: { name: 'FilterInputRange' }
          // filters: [
          //   {
          //     data: {
          //       vals: [],
          //       sVal: '',
          //       fMenu: '',
          //       f1Type: '',
          //       f1Val: '',
          //       fMode: 'and',
          //       f2Type: '',
          //       f2Val: '',
          //     },
          //   },
          // ],
          // filterRender: { name: 'FilterExtend' },
        },
        {
          title: '系统版本',
          width: 50,
          fixed: 'left',
          field: 'productionVersion',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        // filter 分类：
        // 1.简单输入框 FilterInput
        // 2.简单单选框（是/否）filterMultiple: false
        // 3.复杂筛选（包含输入、选择）FilterExtend
        {
          title: '模块',
          width: 70,
          fixed: 'left',
          field: 'groupName',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '页面',
          width: 80,
          fixed: 'left',
          field: 'vuePath',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '问题内容',
          width: 180,
          fixed: 'left',
          field: 'content',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          title: '紧急',
          width: 40,
          fixed: 'left',
          field: 'isPriority',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '登记单位',
          width: 90,
          fixed: 'left',
          field: 'companys',
          filters: [{ data: null }],
          filterRender: { name: 'FilterInput' }
        },
        {
          title: '文档编号',
          width: 50,
          field: 'docNumber',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '类型',
          width: 35,
          field: 'type',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人',
          width: 60,
          field: 'createtor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        // {
        //   title: '调研人', width: 60,  field: 'research',
        //   filters: [{ data: { vals: [], sVal: '', fMenu: '', f1Type: '', f1Val: '', fMode: 'and', f2Type: '', f2Val: '' } }], filterRender: { name: 'FilterExtend' }
        // },
        {
          title: '提出日期',
          width: 85,
          field: 'createDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '截止日期',
          width: 85,
          field: 'dueDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '前端研发',
          width: 70,
          field: 'frontEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端研发',
          width: 70,
          field: 'backEngineer',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端评价人',
          width: 70,
          field: 'frontAssessor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端评价人',
          width: 70,
          field: 'backAssessor',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端工作量',
          width: 70,
          field: 'frontWorkTime',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端工作量',
          width: 70,
          field: 'backWorkTime',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试',
          width: 70,
          field: 'techTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试',
          width: 70,
          field: 'businessTester',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '设计变更',
          width: 150,
          field: 'designHistory',
          slots: {
            default: ({ row, column }) => {
              const isLongContent = true
              return this.formatContentWrap(row, column, 'left', isLongContent)
            }
          },
          exportMethod: ({ row, column }) => {
            // 格式化导出内容
            const isLongContent = true
            const isExport = true
            return this.formatContentWrap(row, column, 'left', isLongContent, isExport)
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
          // filters: [{ data: null }], filterRender: { name: 'FilterInput' }
        },
        {
          title: '说明内容',
          width: 200,
          field: 'comment',
          slots: {
            default: ({ row, column }) => {
              const isMemo = true
              return this.formatContentWrap(row, column, 'left', isMemo)
            }
          },
          exportMethod: ({ row }) => {
            // 注意！不能用原列值导出，会有乱码
            // 只能用后端格式化后的说明列(exportComment)进行导出
            const exportComment = row['exportComment']
            return exportComment
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
          // filters: [{ data: null }], filterRender: { name: 'FilterInput' }
        },
        {
          title: '领导意见',
          width: 80,
          field: 'leaderViews',
          slots: {
            default: ({ row, column }) => {
              const isMemo = true
              return this.formatContentWrap(row, column, 'left', isMemo)
            }
          },
          exportMethod: ({ row }) => {
            // 注意！不能用原列值导出，会有乱码
            // 只能用后端格式化后的说明列(exportLeaderView)进行导出
            const exportLeaderView = row['exportLeaderView']
            return exportLeaderView
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '签名状态',
          width: 80,
          field: 'signStatus',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端解决日期',
          width: 85,
          field: 'frontResolvedDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '前端最后解决日期',
          width: 85,
          field: 'frontResolvedDate',
          formatter: 'formatDate',
          // visible: false
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '后端解决日期',
          width: 85,
          field: 'backResolvedDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '后端最后解决日期',
          width: 85,
          field: 'backResolvedDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
          //  visible: false
        },
        {
          title: '问题状态',
          width: 80,
          field: 'caseStatus',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试确认日期',
          width: 85,
          field: 'techTestDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '技术测试最后确认日期',
          width: 85,
          field: 'techTestDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
          //  visible: false
        },
        {
          title: '天数',
          width: 80,
          field: 'techTestDay',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试确认日期',
          width: 85,
          field: 'businessTestDateStr',
          slots: {
            default: ({ row, column }) => {
              return this.formatContentWrap(row, column)
            }
          },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '业务测试最后确认日期',
          width: 85,
          field: 'businessTestDate',
          formatter: 'formatDate',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
          //  visible: false
        },
        {
          title: '天数',
          width: 80,
          field: 'businessTestDay',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '提出人确认日期',
          width: 85,
          field: 'confirmDate',
          formatter: 'formatDate',
          // slots:
          // {
          //   default: ({ row, column }) => {
          //     return this.formatContentWrap(row, column)
          //   }
          // },
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend', valueFormat: 'date' }
        },
        {
          title: '提出人确认天数',
          width: 80,
          field: 'confirmDay',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '当前节点',
          width: 80,
          field: 'result',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '排序',
          width: 80,
          field: 'sort',
          filters: [
            {
              data: {
                vals: [],
                sVal: '',
                fMenu: '',
                f1Type: '',
                f1Val: '',
                fMode: 'and',
                f2Type: '',
                f2Val: ''
              }
            }
          ],
          filterRender: { name: 'FilterExtend' }
        },
        {
          title: '附件',
          width: 160,
          field: 'fileURL',
          slots: {
            default: ({ row }) => {
              return [
                // 可上传条件：1.有超级权限  2.有附件上传权限
                <el-link
                  disabled={!this.specialAuthority.super && !this.specialAuthority.attachment}
                  onClick={() =>
                    // 打开文件
                    {
                      this.handleOpenFile(row, 'singleRow')
                    }
                  }
                  type='primary'
                  style='margin-right: 10px'
                >
                  <i class='el-icon-upload2' style='margin-right:5px'></i>
                  {'上传'}
                </el-link>,
                <el-link disabled={!row.fileURL} onClick={() => this.openAttachmentDisplay(row)} type='primary'>
                  <i class='el-icon-link' style='margin-right:5px'></i>
                  {'附件'}
                </el-link>
              ]
            }
          }
        }
      ]
    },
    // 获取特殊权限，格式如：specialAuthority:{ '权限名称':true }
    getSpecial() {
      // 汇总界面特殊权限 [super(超级权限) | worktime(工作量评估特殊权限) | leader(领导意见)] | confirmIssued(确认下发)
      this.Authority.special.forEach(v => {
        this.specialAuthority[v.name] = true
      })
    },
    // 获取下拉框值
    async bindCombobox() {
      const { data: res } = await this.$http.post('/Common/ProductVersionSet/list?sqlTitle=all')
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      res.data.forEach(item => {
        const temp = {
          code: 'productionVersion',
          // 产品名称（系统版本）
          name: item.productionVersion,
          // 产品类型
          comment: item.productionType
        }

        this.bodyMenus[0].push(temp)
      })
    },
    // 当前页面是否被锁定，若被锁定则只有超级权限能操作
    async getIsLock() {
      const { data: res } = await this.$http.get('/Common/YKCase/islock')
      if (!res.isSuccess) {
        this.$message.error('获取锁定状态失败')
        return false
      }
      this.isLock = res.data
    },
    // 初始化按钮组
    initButton() {
      // 需要根据特殊权限控制部分按钮可见性
      this.buttonVisible = {
        save: false, // 保存按钮是否显示
        // lock: !!this.specialAuthority.super, // 锁定按钮是否显示
        // unlock: !!this.specialAuthority.super, // 解锁按钮是否显示
        add: false, // 新增按钮是否显示
        update: false, // 编辑按钮是否显示
        delete: false, // 删除按钮是否显示
        sort: false, // 排序按钮是否显示
        search: false, // 查找按钮是否显示
        more: false // 更多按钮是否显示
      }

      this.moreButtonList = [
        {
          // icon: 'el-icon-upload2',
          icon: 'iconfont fjyk-daochu-03-copy',
          name: '导出',
          event: 'export',
          disabled: !this.Authority.edit
        },
        {
          name: '清空筛选',
          icon: 'el-icon-brush',
          disabled: false,
          event: 'clearFilter'
        }
      ]
    },
    /**
     * 获取问题汇总数据
     * @param isResetPager 是否重置当前页码
     * @param isToUncomplete 是否滚动到[未完成]问题的位置
     */
    async getList(isResetPager = false) {
      // let sqlTitle = this.searchSqlTitle
      // if (isToUncomplete) {
      //   sqlTitle = 'toUncomplete'
      //   this.isSearchAll = true
      // }
      if (isResetPager) {
        this.tablePage.currentPage = 1
      }
      // 获取主表数据(全量刷新)
      // 调用情况：1.头部组件在获取产品类型的值后调用  2.切换产品类型后调用  3.点击刷新按钮调用
      if (!this.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }
      const { data: res } = await this.$http.post('/Common/YKCaseHistory/list', {
        menuArgs: this.curProductType,
        sqlTitle: '', // 查看历史不需要过滤
        // 权限
        seeType: this.Authority.seeType,
        pageIndex: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      // 01-26 重新请求数据时，不清空所有筛选条件
      // this.$refs.xTable.clearFilter()
      this.tableData = res.data.rows
      this.tablePage.total = res.data.totals

      // 若需跳转到[未完成]问题，则将当前页码改为后端返回的页码，并跳转
      // if (isToUncomplete) {
      //   this.tablePage.currentPage = res.data.jumpPage
      //   // 查看全部时，需要将表格滚动条滑动到最后一条排序为1的数据
      //   this.setScrollToTarget(res)
      // }
    },

    // 将表格滚动条滑动到最后一条排序为1的数据
    setScrollToTarget(res) {
      let tableDOM = document.getElementsByClassName('vxe-table--body-wrapper body--wrapper')[0]
      tableDOM.scrollTop = 0

      if (this.isSearchAll) {
        setTimeout(() => {
          tableDOM.scrollTop = this.getScrollTop(res)
        }, 500)
      } else {
        setTimeout(() => {
          tableDOM.scrollTop = 0
        }, 500)
      }
    },

    // 获取滚动条需要滚动的距离(滚动到排序为1的最后一条数据)
    getScrollTop(res) {
      // 单元格高度 80px
      const cellHeight = 80
      let count = 0
      for (let row of res.data.rows) {
        if (row.sort !== 1) {
          break
        }
        count++
      }
      return count * cellHeight
    },

    /**
     * 获取主表数据(局部刷新)
     * @description 进行行操作后，进行局部刷新，不改变数据排序
     */
    async getListPart() {
      if (!this.Authority.see) {
        this.$message.warning('您没有查看权限!')
        return
      }
      const { data: res } = await this.$http.post('/Common/YKCase/list', {
        menuArgs: this.curProductType,
        // 局部刷新时，不能过滤本人，提出人确认后会把问题状态改为已解决，因此返回的数据中不包含已通过的数据，因此匹配不上数据从而刷新不了
        sqlTitle: '',
        // 权限
        seeType: this.Authority.seeType,
        // 分页后的逻辑：需获取所有数据来进行匹配，不能使用分页数据（操作后可能导致排序变化，从而在当前页获取不到当前数据）
        pageIndex: 1,
        pageSize: 99999
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      // 分页后的逻辑：局部刷新当前分页内的表格数据
      const tableData = this.$refs.xTable.getTableData().fullData
      const tableIDList = tableData.map(row => {
        return row.id
      })
      this.updateByRows(tableIDList, res)
    },

    // 局部更新
    updateByRows(idList, res) {
      // 更新的行数据
      const updateRow = res.data.rows.filter(item => {
        return idList.includes(item.id)
      })

      for (let i = 0; i < updateRow.length; i++) {
        for (let j = 0; j < this.tableData.length; j++) {
          // 若id匹配，则进行当前行数据的赋值
          if (updateRow[i].id === this.tableData[j].id) {
            this.tableData.splice(j, 1, updateRow[i])
            break
          }
        }
      }
    },
    /**
     * @description 格式化需要换行的列，如说明、签字日期
     * @param {Object} row 行数据
     * @param {Object} column 列数据
     * @param {String} align 文字排版位置，可选值 left | center | right
     * @param {Boolean} isMemo 是否为说明、领导意见、设计变更（若是，则需要分割句内字段；'!#!'用于分割句；'!&!'用于分割句内字段）输出VNode
     * @param {Boolean} isExport 是否为导出字段（若是，则需要分割句内字段；'!#!'用于分割句；'!&!'用于分割句内字段）输出字符串
     */
    formatContentWrap(row, column, align = 'center', isMemo = false, isExport = false) {
      if (row[column.property] == null || row[column.property] == '') {
        return ''
      }
      // 分割后的值
      const wrap = row[column.property].split('!#!')
      // 当前值需要分割句内字段，如说明
      if (isMemo) {
        // 说明
        if (column.property === 'comment') {
          if (isExport) {
            return wrap
              .map(item => {
                // word 固定格式为
                // [0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:id
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return `[${word[0] || '无'}] ${word[1] || '无'} ${word[2] || '无'}: ${word[3] || '无'}`
              })
              .join('\n')
          } else {
            return [
              wrap.map((item, index) => {
                // word 固定格式为
                // [0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:id
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return (
                  <div style={`text-align:${align};white-space:normal; `} key={index}>
                    <span style='color:#555'>{`[${word[0] || '无'}] `}</span>
                    <span>{`${word[1]} ` || '无'}</span>
                    <span style='font-weight: bold'>{`${word[2]}：` || '无'}</span>
                    <span>{word[3] || '无'}</span>
                  </div>
                )
              })
            ]
          }
        } else if (column.property === 'leaderViews') {
          // 领导意见
          return [
            wrap.map((item, index) => {
              // word 固定格式为
              // [0]:类型  [1]:日期 [2]:人名  [3]:说明  [4]:id
              const word = item.split('!&!')

              return (
                <div style={`text-align:${align};white-space:normal; `} key={index}>
                  <span>{`${word[0]} ` || '无'}</span>
                  <span style='font-weight: bold'>{`${word[1]}：` || '无'}</span>
                  <span>{word[2] || '无'}</span>
                </div>
              )
            })
          ]
        } else if (column.property === 'designHistory') {
          if (isExport) {
            return wrap
              .map(item => {
                // word 固定格式为
                // [0]:岗位  [1]:日期  [2]:需求点  [3]:设计变更内容
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return `[${word[0] || '无'}] ${word[1] || '无'} 需求点: ${word[2] || '无'}; 变更内容: ${word[3] ||
                  '无'}`
              })
              .join('\n')
          } else {
            // 设计变更
            return [
              wrap.map((item, index) => {
                // word 固定格式为
                // [0]:岗位  [1]:日期  [2]:需求点  [3]:设计变更内容
                const word = item.split('!&!')

                // 使用div（块级元素）即可实现span分行
                // white-space 可以让 div 内超出宽度的文字换行，但表格自带的 tooltip 会丢失
                return (
                  <div style={`text-align:${align};white-space:normal; `} key={index}>
                    <span style='color:#555'>{`[${word[0] || '无'}] `}</span>
                    <span>{`${word[1]} ` || '无'}</span>
                    <span style='font-weight:bold;'>需求点: </span>
                    <span>{`${word[2]}` || '无'}; </span>
                    <span style='font-weight:bold;'>变更内容: </span>
                    <span>{`${word[3]}` || '无'}</span>
                  </div>
                )
              })
            ]
          }
        }
      }

      // 当前值无需分割句内字段，如签字日期
      return [
        wrap.map((item, index) => {
          // 使用div（块级元素）即可实现分行
          // white-space:normal 实现文字超出div宽度后换行
          return (
            <div style={`text-align:${align};white-space:normal;`} key={index}>
              {' '}
              {item}
            </div>
          )
        })
      ]
    },

    // -------------------------- 表格操作 --------------------------
    // 右键打开菜单
    contextMenuClickEvent({ row, menu }) {
      if (!this.Authority.edit) {
        this.$message.warning('您没有相关操作权限')
        return false
      }

      if (this.isLockCantOperate) {
        this.$message.warning('单据已被锁定，暂时无法操作')
        return false
      }

      this.areas = this.$refs.xTable.getCellAreas()

      // 批量选中checkbox
      if (menu.code === 'selectCheckbox') {
        this.areas.forEach(area => {
          for (let row of area.rows) {
            const CHECKED = true
            this.$refs.xTable.setCheckboxRow(row, CHECKED)
          }
        })
        return
      }

      // 查看本行设计变更
      if (menu.code === 'searchDesign') {
        this.openDesignHistoryWindow({ vuePath: row.vuePath, productionType: this.curProductType })
      }
    },
    // 快捷键
    visibleMethod({ options, column }) {
      options.forEach(allRightMenuList => {
        allRightMenuList.forEach(menuItem => {
          if (!column || !this.Authority.edit) {
            // 隐藏右键菜单：1.点击非表格的地方 2.无编辑权限
            menuItem.visible = false
          } else {
            switch (menuItem.code) {
              case 'selectCheckbox': {
                menuItem.visible = column.type === 'checkbox'
                break
              }
              case 'searchDesign':
                // 有编辑权限且在设计变更列操作时
                menuItem.visible = column.property === 'designHistory'
                break
              // 除 [签名] 和 [撤销签名] 外，其他列的右键菜单显示条件：1.为当前列 2.有超级权限(super)
              default: {
                const isCanShow = () => {
                  return !!this.specialAuthority.super && menuItem.code === column.property
                }
                const isShowMenu = isCanShow()
                menuItem.visible = isShowMenu
                break
              }
            }
          }
        })
      })
      return true
    },
    // 点击事件
    cellContextMenuEvent() {
      if (!this.Authority.edit) {
        return false
      }

      if (this.isLockCantOperate) {
        this.$message.warning('单据已被锁定，暂时无法操作')
        return false
      }

      this.areas = this.$refs.xTable.getCellAreas()
    },

    // 判断当前行是否已保存
    isRowSave(row) {
      // id存在且大于0即说明当前行已保存
      return row.id && row.id > 0
    },

    // 打开天数评估弹窗
    openDaySelectModal() {
      this.$refs.DaySelect.formVisible = true
    },

    // 切换产品类型
    changeSelect(type) {
      // 注意！每次切换必须缓存产品类型值，才能在保存和activated触发时取到当前选择的类型
      this.optionsValue = type
      this.$store.commit('set_productType', this.optionsValue)
      // 重新加载列，可以清除列头筛选（第二个参数根据isSearchAll来显示，如果是[查看本人]，则无需跳转）
      this.getList(true, this.isSearchAll)
      this.InitColumns()
      this.$nextTick(() => {})
    },

    // 双击查看明细数据
    // params: { row, rowIndex, column, columnIndex }, event
    handleDbClick({ row, column }) {
      // 清除表格内的 tooltip
      this.$refs.xTable.closeTooltip()

      if (column.property === 'designHistory') {
        // 双击设计变更列时，打开设计变更
        this.openDesignHistoryWindow({ vuePath: row.vuePath, productionType: this.curProductType })
      } else {
        this.openInstructionEditModal()
        this.setModalData(row)
      }
    },
    // 打开问题编辑弹窗(单条说明)
    openInstructionEditModal() {
      this.$refs.InstructionEdit.isShow = !this.$refs.InstructionEdit.isShow
    },
    // 设置弹窗数据(单条说明)
    setModalData(rowData) {
      const data = JSON.parse(JSON.stringify(rowData))
      this.$refs.InstructionEdit.form = data
      // 当前页的所有行id（用于上一条、下一条）
      this.$refs.InstructionEdit.curPageRowData = JSON.parse(JSON.stringify(this.tableData))
      // 当前行id
      this.curSelectID = rowData.id
    },
    // 设置单元格颜色
    // 单元格颜色优先于整行颜色，则需先单独匹配单元格，再匹配整行
    tableCellStyle({ row, column }) {
      // [是否紧急] 为是：单元格显示红色
      if (
        (column.property === 'isPriority' && row.isPriority === '是') ||
        (column.property === 'type' && row.type === '错误')
      ) {
        return {
          backgroundColor: this.cellBgColorMap['red'],
          color: this.cellTextColorMap['red']
        }
      }

      // [说明/领导意见] 不为空：单元格显示浅棕色
      if (
        // 注意！判断 null 应放在判断空字符串前面，因为null没有 trim 方法
        (column.property === 'comment' && row.comment != null && row.comment.trim() !== '') ||
        (column.property === 'leaderViews' && row.leaderViews != null && row.leaderViews.trim() !== '')
      ) {
        return {
          backgroundColor: this.cellBgColorMap['orange'],
          color: this.cellTextColorMap['orange']
        }
      }

      // [问题状态] 超期未解决：整行粉红色
      // [问题状态] 超期已解决：整行浅绿色
      // [问题状态] 已解决：整行浅黄色
      // [问题状态] 不处理：整行浅紫色
      const statusMap = {
        超期未解决: 'pink',
        超期已解决: 'green',
        已解决: 'yellow',
        不处理: 'purple'
      }
      const rowValue = row['caseStatus']
      const bgColor = statusMap[rowValue]
      return {
        backgroundColor: this.cellBgColorMap[bgColor],
        color: this.cellTextColorMap[bgColor]
      }
    },

    // -------------------------- 按钮工具栏 --------------------------
    // 切换查询面板可见性
    changeSearchFormShow() {
      this.searchFormVisible = !this.searchFormVisible
    },

    // 点击查询，切换查看模式（全查 | 过滤本人）
    search() {
      this.isSearchAll = !this.isSearchAll
      this.$message.success(this.isSearchAll ? '查看全部' : '查看本人')
      this.$nextTick(() => {
        this.getList(true, this.isSearchAll)
      })
    },
    // 点击刷新按钮，刷新数据和锁定状态
    refresh(isResetPager = false, isToUncomplete = false) {
      // 刷新当前页面数据
      this.getList(isResetPager, isToUncomplete)
      // 刷新锁定状态
      this.getIsLock()
    },
    // 导出
    export() {
      this.$refs.xTable.exportData({
        filename: this.ykDateFormat('yyyy-MM-dd', new Date()) + '问题汇总和解决情况表',
        type: 'xlsx',
        columnFilterMethod({ column }) {
          let unExportList = [
            'isIssued',
            'fileURL',
            'frontResolvedDate',
            'backResolvedDate',
            'techTestDate',
            'businessTestDate',
            'frontAssessor',
            'backAssessor',
            'designHistory'
          ]
          return !['checkbox', 'seq'].includes(column.type) && !unExportList.includes(column.property)
        }
      })
    },

    // 保存所拉选的行ID
    getAreasIDList() {
      let res = []
      // 将行id保存
      this.areas.forEach(area => {
        for (let row of area.rows) {
          res.push(row.id)
        }
      })
      return res
    },

    // 员工选择框返回值
    sureBackPerson(selectRecords) {
      // selectRecords: {
      //   id
      //   num // 用户名
      //   name // 姓名
      //   post // 岗位
      // }
      this.changePerson(this.curSelectCol, selectRecords.name)
    },
    // 修改人员
    async changePerson(colName, newPerson) {
      // 获取选中行的id
      const idList = [...this.getAreasIDList()]

      const { data: res } = await this.$http.post('/Common/YKCase/handler', {
        iDs: idList,
        // 新人员
        handlerName: newPerson,
        // 岗位类型
        handlerType: this.PERSONTYPE[colName]
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)
      this.getListPart(idList)
      // this.getList(false, false)
    },

    // 打开附件上传弹窗
    // 2022-09-08 新的附件方式：根据行id来获取附件
    openAttachmentDisplay(row) {
      this.$refs.AttachmentDrawer.attachmentDrawerCanUnLoad = false
      this.$refs.AttachmentDrawer.rowId = row.id

      this.$nextTick(() => {
        this.attachmentDisplay = true
      })
    },

    // #endregion
    clearFilter() {
      this.$message.info('清空筛选中...')
      // 加延迟可以让提示在点击时弹出，而不是在清除后弹出
      setTimeout(() => {
        this.$refs.xTable.clearFilter()
      }, 100)
    },

    // 切换分页
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.getList()
    },

    // 合计
    footerMethod({ columns, data }) {
      const sums = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('合计')
        } else {
          let sumCell = null
          switch (column.property) {
            case 'frontWorkTime':
            case 'backWorkTime':
              sumCell = this.$utils.sum(data, column.property)
              break
          }
          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    }
  },
  computed: {
    tableHeight() {
      let isSearchForm = this.searchFormVisible
      let isToolBar = true

      // 若有查询框，则共有四段 margin; 否则只有表格的两段 margin
      let tableMargin = isSearchForm ? this.heightConfig.mainMargin * 4 : this.heightConfig.mainMargin * 2
      return this.tableHeightComputed(tableMargin + this.topBottomMargin, isSearchForm, isToolBar)
    },
    // 当前选中的产品类型
    curProductType() {
      return this.$store.state.productType
    },
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    // 当前用户的岗位
    curUserGangWei() {
      // 可能存在多岗，用逗号分隔
      const res = this.$store.state.userInfo.gangWei.split(',')
      return res
    },
    // 是否全量查询问题的过滤条件
    searchSqlTitle() {
      if (this.isSearchAll) {
        return ''
      } else {
        return 'default'
      }
    },
    // 是否因为锁定而无法操作，判断条件：
    // 1.无超级权限 2.当前状态被锁定
    isLockCantOperate() {
      if (!this.specialAuthority.super && this.isLock) {
        // 无法操作当前页面
        return true
      }
      // 可以操作当前页面
      return false
    }
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  margin: 0 auto;
  height: calc(100vh - @header-height);
  overflow: hidden;
}
.card {
  margin: @main-margin;
  box-shadow: #bebebe 2px 2px 10px;
  border-radius: 10px;
  overflow: hidden;
}
.search-dv {
  background-color: aquamarine;
  height: 100px;
  margin: @main-margin 10px;
}

.toolbar-dv {
  padding: 10px;
}

.table-dv {
  padding: @topBottomMargin;
}

// 查找面板过渡渐变
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

// 行高度，需要比 row-config 的 height 多20px，可以让内容与单元格之间有内边距
/deep/ .vxe-body--row {
  height: 80px !important;
}
/deep/ .el-link.el-link--primary.is-disabled {
  color: #999999;
}
</style>
